// 叫車紀錄中訂單詳細資訊的取消訊息列表
export const cancelMsg = [
  {
    value: 0,
    label: '抱歉! 乘客已取消本次派遣',
  },
  {
    value: 1,
    label: '中心將取消本次派遣',
  },
  {
    value: 2,
    label: '辛苦了！未見乘客，請先離開，祝生意興榮',
  },
  {
    value: 3,
    label: '抱歉! 取消車趟，請車輛重新按排班',
  },
  {
    value: 4,
    label: '抱歉! 乘客收線，中心取消本次派遣',
  },
]



// WEBPACK FOOTER //
// ./src/constants/msg.js